import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import _ from 'lodash';
import { HBox, VBox } from '../../../components/Box';
import { FileDownload, Times, Upload, TextIcon, Calendar } from '../../../components/Icon';
import { FormField } from '../../../components/FormFields';
import { DecoratorLabel, Input } from '../../../components/Input';
import { Button } from '../../../components/Buttons';
import { WithInstallationClient } from '../../../components/WithInstallationClient/WithInstallationClient';
import { addDocument, deleteDocument } from '../actions';
import { addWebloginDocument } from '../../Weblogin/actions';
import { setVehicleProperty } from '../../Vehicles/actions';
import { getOriginalFileNameOptions } from '../helpers';
import { Permission } from '../../../components/Permission';
import { VEHICLE_DOCUMENTS_UPLOAD, COMPANY_DOCUMENTS_UPLOAD } from '../../../components/Permission/constants';
import { selectConfig, selectMe } from '../../Api/selectors';
import { WIENTJES_INSTALATION, HOOIKAMMER_INSTALLATION } from '../../../containers/App/constants';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import cn from 'classnames';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './documentsList.module.css';
import { WEBLOGIN_VEHICLE_DOCUMENT_NAMES_CREDITOR, WEBLOGIN_VEHICLE_DOCUMENT_NAMES_DEBITOR } from '../constants';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

dayjs.extend(customParseFormat);
const STATE = {
  edit: null,
  value: '',
  isRequired: false,
  addDocument: false,
  addValue: '',
  deleteDocumentConfirm: null,
  documentDto: null,
};

const Container = styled.div`
  width: ${props => (props.fullWidth ? '100%' : '')};
  .req-field {
    color: red;
  }
`;

const Document = styled.div`
  margin-bottom: 15px;
  display: flex;
  width: 100%;

  > .box {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    .button {
      min-width: 50px;
      width: 50px;
      margin: 1px;
    }
  }
  .document-col1 {
    padding: 6px;
    width: 85%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .name {
      font-weight: 600;
    }
  }
  .document-col2 {
    width: 15%;
    align-items: flex-end;
  }
  .preview-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    margin-right: 15px;
    background-color: var(--color-new-info);
    color: var(--color-new-white);
    border-radius: 0.375rem;
  }
  .preview-icon:hover {
    background-color: var(--color-new-info-hover);
  }
`;

const UploadBtnBlock = styled.div`
  width: 100%;

  .label-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const InputFile = styled.input``;

/* eslint-disable react/prefer-stateless-function */
class DocumentsListComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  fetchEntity() {
    console.log('this.props.fetchEntity', this.props.fetchEntity);
    this.props.fetchEntity;
  }

  get entityId() {
    return this.props.entityId;
  }

  get entityType() {
    return this.props.entityType;
  }

  get document() {
    return this.props.document ?? {};
  }

  get weblogin() {
    return this.props.me.weblogin;
  }

  get fileInputLabel() {
    let label = this.state.documentDto?.file?.name
      ? this.state.documentDto?.file?.name
      : this.lbl('documents.upload.drag_and_drop_or_select_file');

    return label;
  }

  get webloginDocuments() {
    const originalFileNames = this.props.isCreditor
      ? WEBLOGIN_VEHICLE_DOCUMENT_NAMES_CREDITOR
      : WEBLOGIN_VEHICLE_DOCUMENT_NAMES_DEBITOR;

    return this.props.items?.filter(d => originalFileNames?.includes(d?.originalFilename));
  }

  addDocument() {
    if (!this.state.documentDto?.originalFilename) {
      return this.setState({ isRequired: true });
    }
    if (this.state.documentDto?.extra?.co2_rdw) {
      this.addDocumentWIthSetVehicleProperties(this.reset.bind(this));
      return;
    }
    this.props.addDocument(this.entityId, this.entityType, this.state.documentDto, this.weblogin, this.reset.bind(this));
  }

  addDocumentWIthSetVehicleProperties(callback) {
    const dto = this.state.documentDto;
    this.props.addDocument(this.entityId, this.entityType, dto, this.weblogin, () => {
      let extraFields = dto?.extra;
      if (typeof dto?.extra === 'string') {
        extraFields = JSON.parse(dto.extra);
      }
      ['co2_rdw'].map((propertyName, index) => {
        const value = extraFields?.[propertyName];
        if (value) {
          this.props.setVehicleProperty(this.entityId, propertyName, value);
        }
      });
    });
    return callback();
  }

  deleteDocument() {
    const { documentId } = this.state.deleteDocumentConfirm;

    this.props.deleteDocument(this.entityId, this.entityType, documentId, this.reset.bind(this));
  }

  dropdown() {
    let vals = getOriginalFileNameOptions(this.props.entityType, this.weblogin, this.props.isCreditor, this.props.isDebitor);
    if (this.props.singleType) {
      vals = [this.props.singleType];
    }

    const options = _.orderBy(
      vals.map(val => ({
        label: this.lblStr(`${this.props.entityType}.details.documents.fields.${val}`),
        value: val,
      })),
      val => val.label,
    );

    const value = options.find(o => o.value == this.state.documentDto?.originalFilename);

    return (
      <SearchSelect name="originalFilename" options={options} value={value} onChange={this.onDropDownChange.bind(this)} />
    );
  }

  datePicker() {
    let format = this.state.documentDto?.expirationDate?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;

    let selected =
      this.state.documentDto?.expirationDate &&
      this.state.documentDto?.expirationDate !== 'null' &&
      dayjs(this.state.documentDto?.expirationDate, format);
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          dateFormat="dd-MM-yyyy"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            // let d = dayjs(date).format('DD-MM-YYYY');
            let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
            d &&
              this.setState((prev, props) => {
                return { ...prev, documentDto: { ...prev.documentDto, expirationDate: d } };
              });
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  renderEmissionFields() {
    if (env.clientId !== AppClientId.INDEWAL || this.state.documentDto?.originalFilename !== 'regplate_foreign') return null;
    return (
      <>
        <div>
          <div>{this.lbl('vehicle.property.co2_rdw')}</div>
          <FormField>
            <Input
              name="co2_rdw"
              onChange={this.onInputChange.bind(this)}
              rightDecoration={<DecoratorLabel>g/KM</DecoratorLabel>}
            />
          </FormField>
        </div>
      </>
    );
  }

  renderWithPermission = child => {
    if (this.entityType === 'company') {
      return <Permission permission={COMPANY_DOCUMENTS_UPLOAD}>{child}</Permission>;
    }
    if (this.entityType === 'vehicle') {
      return <Permission permission={VEHICLE_DOCUMENTS_UPLOAD}>{child}</Permission>;
    }
    return child;
  };

  render() {
    const documents = this.props.items;

    if (!documents) return null;
    const documentItems = this.entityType == 'vehicle' && this.weblogin ? this.webloginDocuments : documents;

    return (
      <Container fullWidth={this.props.fullWidth}>
        {this.renderAdd()}
        {this.renderDeleteDocument()}
       {this.props.fromKanban ? '' :  <VBox>{documentItems.map(d => this.renderDocument(d, this.entityId, this.entityType))}</VBox>}
        {!this.props.invoiceDetails &&
          !this.props.kanban &&
          this.renderWithPermission(
            <HBox className={styles.containerButtons}>
              <UploadBtnBlock>
                <Button className={styles.buttonUpload} upload onClick={this.setStateFn({ addDocument: true })}>
                  <div className="label-block">
                    <Upload /> <span>{this.props.label || this.lbl('documents.upload.select_file_to_upload')}</span>
                  </div>
                </Button>
              </UploadBtnBlock>
            </HBox>,
          )}
      </Container>
    );
  }

  renderAdd() {
    if (true !== this.state.addDocument) {
      return null;
    }

    return (
      <ModalComponent
        className={styles.modal}
        onClose={this.reset.bind(this)}
        title={this.lbl('vehicle.details.documents.modal.add')}
      >
        <Container>
          <div className={styles.containerControlForm}>
            <label className="form-label">{this.lbl('vehicle.details.documents.fields.originalFilename')}</label>
            {this.state.isRequired && (
              <p className="req-field">* {this.lbl(`vehicle.details.documents.modal.require_file_name`)}</p>
            )}
            {this.dropdown()}
          </div>
          <WithInstallationClient appClientId={WIENTJES_INSTALATION.APP_CLIENT_ID}>
            {this.state.documentDto?.originalFilename === 'id' && (
              <div className={styles.containerControlForm}>
                <label className="form-label">{this.lbl('vehicle.details.documents.fields.expirationDate')}</label>

                {this.datePicker()}
              </div>
            )}
            {this.state.documentDto?.originalFilename === 'kvk' && (
              <div className={styles.containerControlForm}>
                <label className="form-label">{this.lbl('vehicle.details.documents.fields.expirationDate')}</label>
                {this.datePicker()}
              </div>
            )}
          </WithInstallationClient>
          <WithInstallationClient appClientId={HOOIKAMMER_INSTALLATION.APP_CLIENT_ID}>
            {this.state.documentDto?.originalFilename === 'offerte' && (
               <div className={styles.containerControlForm}>
               <label className="form-label">{this.lbl('vehicle.details.documents.fields.offertebedrag')}</label>
   
               <input className="form-control" name="offertebedrag" onChange={this.onInputChange.bind(this)} />
             </div>
            )}
           
          </WithInstallationClient>
          {(this.state.documentDto?.originalFilename === 'key_invoice' ||
            this.state.documentDto?.originalFilename === 'repair_invoice' ||
            this.state.documentDto?.originalFilename === 'key_invoice' ||
            this.state.documentDto?.originalFilename === 'parts_invoice') && (
            <div className={styles.containerControlForm}>
              <label className="form-label" style={{ color: 'red' }}>
                {this.lbl('vehicle.details.documents.fields.warning_invoice')}
              </label>
            </div>
          )}

          {this.renderEmissionFields()}

          <div className={styles.containerControlForm}>
            <label className="form-label">{this.lbl('vehicle.details.documents.fields.description')}</label>

            <input className="form-control" name="description" onChange={this.onInputChange.bind(this)} />
          </div>
          <div className={styles.containerControlForm}>
            <HBox className={styles.containerButtons}>
              <UploadBtnBlock>
                <input
                  type="file"
                  name="file"
                  accept="*"
                  onChange={this.onFileInputChange.bind(this)}
                  id="file"
                  className={styles.inputfile}
                />
                <label for="file">
                  {
                    <div className="label-block">
                      <Upload /> <span>{this.fileInputLabel}</span>
                    </div>
                  }
                </label>
              </UploadBtnBlock>
            </HBox>
          </div>

          {this.isCarcollectDocumentType(this.state.documentDto?.originalFilename) &&
           
            <div className={styles.containerControlForm}>
              <label className="form-label">
                <input
                  type="checkbox"
                  name="carcollect"
                  checked={this.state.documentDto?.extra?.carcollect !== false}
                  onChange={this.onCheckboxChange.bind(this)}
                  style={{ marginRight: '8px' }}
                />
                {this.lbl('vehicle.details.documents.fields.save_to_carcollect')}
              </label>
            </div>
          }

          <div className="d-flex gap-2 mt-2">
            <ButtonComponent style={'ButtonSoftEdit'} onClick={this.addDocument.bind(this)}>
              {this.lbl('save')}
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </Container>
      </ModalComponent>
    );
  }

  getLocalizedOriginalFilename(document) {
    const separator1 = '_task';
    const separator2 = '_SALLAND';
    let separator;
    let separatorIndex = document.originalFilename.indexOf(separator1);

    if (separatorIndex === -1) {
      separatorIndex = document.originalFilename.indexOf(separator2);
      separator = separatorIndex !== -1 ? separator2 : null;
    } else {
      separator = separator1;
    }

    if (separator) {
      const firstPart = document.originalFilename.substring(0, separatorIndex);
      const restPart = document.originalFilename.substring(separatorIndex);

      return (
        <>
          {this.lbl(`${this.props.entityType}.details.documents.fields.${firstPart}`)}
          <span>{`${restPart}`}</span>
        </>
      );
    } else {
      return this.lbl(`${this.props.entityType}.details.documents.fields.${document.originalFilename}`);
    }
  }

  renderDocument(document) {
    const shouldRender = this.props.nameTask ? document.originalFilename.includes(this.props.nameTask) : true;

    if (!shouldRender || document.type?.indexOf('photo_') === 0) {
      return null;
    }
    return (
      <Document key={`${document.id}`} onClick={this.weblogin ? () => {} : () => this.editDocument(document)}>
        <HBox className={styles.container} left>
          <VBox className="document-col1">
            <div className="preview-icon">
              <FileDownload />
            </div>
            <div>
              <div className="name">{this.getLocalizedOriginalFilename(document)}</div>
              <div className="descr">{document.description}</div>
              <div className="date">{dayjs(document.createdAt).format('DD-MM-YYYY')}</div>

              <WithInstallationClient appClientId={WIENTJES_INSTALATION.APP_CLIENT_ID}>
                {document.originalFilename === 'id' && document.expirationDate ? (
                  <HBox left>
                    <strong className="date">
                      {this.lbl(`details.documents.fields.expirationDate`)}:&nbsp;
                      {dayjs(document.expirationDate).format('DD-MM-YYYY')}
                    </strong>
                  </HBox>
                ) : null}
                {document.originalFilename === 'kvk' && document.expirationDate ? (
                  <HBox left>
                    <strong className="date">
                      {this.lbl(`details.documents.fields.expirationDate`)}:&nbsp;
                      {dayjs(document.expirationDate).format('DD-MM-YYYY')}
                    </strong>
                  </HBox>
                ) : null}
              </WithInstallationClient>

                <WithInstallationClient appClientId={HOOIKAMMER_INSTALLATION.APP_CLIENT_ID}>
                  {document.originalFilename === 'offerte' ? (
                    <HBox left>
                      <strong className="date">
                        {this.lbl(`details.documents.fields.offertebedrag`)}:&nbsp;
                        {document?.extra?.offertebedrag ?? document.offertebedrag /* fallback just in case */}
                      </strong>
                    </HBox>
                  ) : null}
                </WithInstallationClient>

            </div>
          </VBox>

          {this.weblogin ? (
            <VBox className="document-col2">
              <Button small onClick={() => window.open(document.url)}>
                <FileDownload />
              </Button>
            </VBox>
          ) : (
            <VBox className={cn('document-col2', styles.containerButtons)}>
              <Button className={styles.buttonDownload} small onClick={() => window.open(document.url)}>
                <FileDownload />
              </Button>
              <Button
                className={styles.buttonDelete}
                small
                onClick={this.setStateFn({ deleteDocumentConfirm: { documentId: document.id } })}
              >
                <Times />
              </Button>
            </VBox>
          )}
        </HBox>
      </Document>
    );
  }

  renderDeleteDocument() {
    if (!this.state.deleteDocumentConfirm) return null;
    return (
      <ModalComponent
        className={styles.modal}
        onClose={this.reset.bind(this)}
        title={this.lbl('vehicle.details.documents.modal.delete')}
      >
        <div className="d-flex gap-2">
          <Button isPrimary onClick={this.deleteDocument.bind(this)}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </div>
      </ModalComponent>
    );
  }

  editDocument(document) {
    this.setState({ edit: document.id, document });
  }

isExtraDataField(field) {
  return ['co2_rdw', 'offertebedrag'].includes(field);
}

  onInputChange(evt) {
    const { name, value } = evt.target;
    if (this.isExtraDataField(name)) {
      this.setState((prev, props) => {
        return {
          ...prev,
          documentDto: { ...prev.documentDto, extra: { ...(prev.documentDto?.extra ?? {}), [name]: value } },
        };
      });
    } else {
      this.setState((prev, props) => {
        return { ...prev, documentDto: { ...prev.documentDto, [name]: value } };
      });
    }

    return this;
  }

  onDropDownChange(evt) {
    this.setState(prev => {
      const originalFilenameValue = this.props.nameTask ? evt.value + '_' + this.props.nameTask : evt.value;
      const isCarcollectDoc = this.isCarcollectDocumentType(originalFilenameValue);

      return {
        ...prev,
        isRequired: false,
        documentDto: {
          ...prev.documentDto,
          originalFilename: originalFilenameValue,
          extra: isCarcollectDoc ? { carcollect: true } : {},
        },
      };
    });
  }

  onFileInputChange(evt) {
    const { name } = evt.target;
    const value = evt.target.files[0];
    this.setState((prev, props) => {
      return { ...prev, documentDto: { ...prev.documentDto, [name]: value } };
    });
    return this;
  }

  onCheckboxChange(evt) {
    const { name, checked } = evt.target;
    this.setState((prev, props) => {
      return {
        ...prev,
        documentDto: {
          ...prev.documentDto,
          extra: {
            ...(prev.documentDto?.extra ?? {}),
            [name]: checked,
          },
        },
      };
    });
  }

  isCarcollectDocumentType(originalFilename) {
    const carcollectDocumentTypes = ['release_report', 'tdn', 'invoice_sales'];
    return carcollectDocumentTypes.includes(originalFilename);
  }
}

DocumentsListComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
    me: selectMe(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addDocument(entityId, entityType, documentDto, weblogin = false, callback) {
      if (weblogin) {
        return dispatch(addWebloginDocument(entityId, documentDto, callback));
      }
      dispatch(addDocument(entityId, entityType, documentDto, callback));
    },
    deleteDocument(entityId, entityType, documentId, callback) {
      dispatch(deleteDocument(entityId, entityType, documentId, callback));
    },
    setVehicleProperty(vehicleId, propertyName, propertyValue, callback) {
      dispatch(setVehicleProperty(vehicleId, propertyName, propertyValue, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const DocumentsList = compose(withConnect, withRouter, injectIntl)(DocumentsListComp);
